import React, { createContext, useContext, useState, useEffect } from 'react';
import { aicisAPI, abvigAPI } from '../services/api';

const DashboardContext = createContext();

export function DashboardProvider({ children }) {
  const [aicisStats, setAicisStats] = useState(null);
  const [abvigStats, setAbvigStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const loadStats = async () => {
    try {
      setLoading(true);
      const [aicisData, abvigData] = await Promise.all([
        aicisAPI.getDashboardStats(),
        abvigAPI.getDashboardStats(),
      ]);
      setAicisStats(aicisData);
      setAbvigStats(abvigData);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, [refresh]);

  const refreshData = () => setRefresh(prev => !prev);

  return (
    <DashboardContext.Provider
      value={{
        aicisStats,
        abvigStats,
        loading,
        refreshData,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboard() {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
}